import { err, ok } from '@xlearn/common';
import { TimeInterval, parseTimeInterval, timeIntervalToString, parseTime, Time, timeToString  } from '../../api';
import { SchemaError, ErrorCode } from '../schema-engine';
import { parseInteractionType, InteractionType, InteractionResult, parseInteractionResult } from './interaction';

export function setInteractionType(current: InteractionType, value: string) {

  const parsed = parseInteractionType(value);
  if (!parsed.success) {
    return err(new SchemaError(ErrorCode.incorrectDataType, value));
  }

  return ok(parsed.value);
}

export function getInteractionType(value: string) {
  return ok(value);
}

export function setInteractionResult(current: InteractionResult, value: string) {

  const parsed = parseInteractionResult(value);
  if (!parsed.success) {
    return err(new SchemaError(ErrorCode.incorrectDataType, `Invalid interaction result '${value}'`));
  }

  return ok(parsed.value);
}

export function getInteractionResult(value: string) {
  return ok(value);
}

export function setLatency(current: TimeInterval, value: string) {
  const parsed = parseTimeInterval(value);
  if (parsed === false) {
    return err(new SchemaError(
      ErrorCode.incorrectDataType,
      `Unable to parse timeinterval value '${value}'`));
  }
  return ok(parsed);
}

export function getLatency(value: TimeInterval) {
  return ok(timeIntervalToString(value));
}

export function setTimestamp(current: Time, value: string) {
  const parsed = parseTime(value);
  if (parsed === false) {
    return err(new SchemaError(
      ErrorCode.incorrectDataType,
      `Unable to parse time value '${value}'`));
  }
  return ok(parsed);
}

export function getTimestamp(value: Time) {
  return ok(timeToString(value));
}

